import {all, call, delay, put, takeLeading} from 'redux-saga/effects';
import {actions, ActionType} from './action';
import {getEnterInfo, getLuckydrawReward, getRaffle, getResult} from './apiGet';
import {pAlert} from '../../common/component/PAlert';
import {ButtonSet} from '../../common/type/alert';
import callApi from '../../common/util/api';
import {makeFetchSaga} from '../../common/util/fetch';
import {routeBack} from '../../common/util/PageRouter';
import {typedSelect} from '../../common/util/saga';

function* fetchLuckydrawReward(
  action: ReturnType<typeof actions.fetchLuckydrawReward>
) {
  const {drawId, rewardId, luckydrawId} = action.payload;

  const {success, data} = yield call(callApi, {
    url: `gift/v1/rewards/${rewardId}/lucky-draw/${drawId}`,
    params: {
      id: luckydrawId,
    },
  });

  if (success) {
    const luckydraw = getLuckydrawReward(data);
    yield put(actions.setValue('luckydrawReward', luckydraw));
  }
}

function* fetchResult(action: ReturnType<typeof actions.fetchResult>) {
  const {drawId, rewardId, luckydrawId, theme} = action.payload;
  const startTime = Date.now();
  const {success, data} = yield call(callApi, {
    url: `gift/v1/rewards/${rewardId}/lucky-draw/${drawId}/receive`,
    method: 'post',
    data: {
      id: luckydrawId,
    },
  });

  if (success) {
    if (theme === 'slotMachine') {
      const elapsed = Date.now() - startTime;
      const duration = Math.max(1, Math.random() * 1000 + (2200 - elapsed));
      yield delay(duration);
    }

    yield put(actions.setValue('result', getResult(data.result)));
  }
}

function* fetchEnterInfo(action: ReturnType<typeof actions.fetchEnterInfo>) {
  const {presentId, rewardId, luckydrawId} = action.payload;

  const {success, data} = yield call(callApi, {
    url: `gift/v1/present/${presentId}/info-to-receive`,
    params: {
      rewardId,
      id: luckydrawId,
    },
  });

  if (success) {
    const luckydrawReward = yield* typedSelect(
      state => state.luckydraw.luckydrawReward
    );

    if (luckydrawReward?.isReceived) {
      const enterInfo = getEnterInfo(data);

      yield put(
        actions.setValue('enterInfo', {
          ...enterInfo,
          prize: luckydrawReward.result.prize,
        })
      );
    }
  }
}

function* fetchSubmitForms(
  action: ReturnType<typeof actions.fetchSubmitForms>
) {
  const {forms, presentId, rewardId, luckydrawId} = action.payload;

  const {success} = yield call(callApi, {
    url: `gift/v1/present/${presentId}/info-to-receive`,
    method: 'post',
    data: {
      forms,
      rewardId,
      id: luckydrawId,
    },
  });

  if (success) {
    pAlert({
      buttonSet: ButtonSet.Confirm,
      title: t => t('luckydraw_global_entered_popup'),
      titleClassName: 's16-medium-white light:text-black',
    }).then(({okClicked}) => {
      okClicked && routeBack();
    });
  }
}

function* fetchRaffle(action: ReturnType<typeof actions.fetchRaffle>) {
  const {uid, rewardId} = action.payload;

  const {success, data} = yield call(callApi, {
    url: 'gift/v1/views/raffle',
    params: {
      rewardId,
      uid,
    },
  });

  if (success) {
    yield put(actions.setValue('result', getRaffle(data)));
  }
}

export default function* saga() {
  yield all([
    takeLeading(
      ActionType.FetchLuckydrawReward,
      makeFetchSaga({fetchSaga: fetchLuckydrawReward, canCache: false})
    ),
    takeLeading(
      ActionType.FetchResult,
      makeFetchSaga({fetchSaga: fetchResult, canCache: false})
    ),
    takeLeading(
      ActionType.FetchEnterInfo,
      makeFetchSaga({fetchSaga: fetchEnterInfo, canCache: false})
    ),
    takeLeading(
      ActionType.FetchSubmitForms,
      makeFetchSaga({fetchSaga: fetchSubmitForms, canCache: false})
    ),
    takeLeading(
      ActionType.FetchRaffle,
      makeFetchSaga({fetchSaga: fetchRaffle, canCache: false})
    ),
  ]);
}
